// extracted by mini-css-extract-plugin
module.exports = {"container":"CitySelect_container__TumMZ","selectCityList":"CitySelect_selectCityList__0nka4","item":"CitySelect_item__TugpQ"};